import http from "@/settings/apiSettings"

class CrmSalesDataService {
  save(data: any): Promise<any> {
    return http.clientComercialOdata.post("/CRM_Sales", data);
  }

  update(key: string, data: any): Promise<any> {
    return http.clientComercialOdata.patch(`/CRM_Sales(${key})`, data);
  }

  getById(key: string, expand = ''): Promise<any> {
    return http.clientComercialOdata.get(`/CRM_Sales(${key})?${expand}`);
  }

  // În serviciul tău CrmSales
  getPermissions(): Promise<any> {
    // Apelăm endpoint-ul simplu, nu prin OData prefix
    return http.clientComercialOdata.get('CRM_Sales/GetWritePermissions');
  }
}

export default new CrmSalesDataService();